'use strict';

var _ = require('lodash');
function FaresOptimizerMapHostLadderSelectedCompetitorService() {
  var mappedValues = {};
  function initialize(hostsLadder) {
    _.transform(hostsLadder, function (accumulator, hostLadder) {
      var hostLadderKey = getHostLadderKey(hostLadder.data);
      var selectedCompetitor = _.find(hostLadder.data.entryLevelBenchmark, {
        isSelectedCompetitor: true
      });
      if (selectedCompetitor) {
        mappedValues[hostLadderKey] = selectedCompetitor.fbc;
      }
      return mappedValues;
    }, mappedValues);
  }
  function getHostLadderKey(selectedHostLadder) {
    return [selectedHostLadder.carrier, selectedHostLadder.fbc, selectedHostLadder.season, selectedHostLadder.pos].join(':');
  }
  function isCompetitorAlreadySelectedByAnotherLadder(competitorFBC, selectedHostLadder) {
    var hostLadderKey = _.findKey(mappedValues, function (mappedValue) {
      return mappedValue === competitorFBC;
    });
    return hostLadderKey && hostLadderKey !== getHostLadderKey(selectedHostLadder);
  }
  return {
    initialize: initialize,
    getHostLadderKey: getHostLadderKey,
    isCompetitorAlreadySelectedByAnotherLadder: isCompetitorAlreadySelectedByAnotherLadder
  };
}
FaresOptimizerMapHostLadderSelectedCompetitorService.$inject = [];
module.exports = FaresOptimizerMapHostLadderSelectedCompetitorService;